"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShreddingModesFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../../../composite/form/fields/form-text-field");
const form_panel_1 = require("../../../../composite/form/fields/form-panel");
const identifier_1 = require("../../common/identifier");
const form_number_field_1 = require("../../../../composite/form/fields/form-number-field");
function ShreddingModesFields() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_RECORDS_PANEL_TITLE", defaultMessage: "Skartan\u00ED re\u017Eim" }) },
            react_1.default.createElement(form_text_field_1.FormTextField, { name: "symbol", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_SHREDDING_MODES_FIELD_LABEL_SYMBOL", defaultMessage: "Skarta\u010Dn\u00ED znak" }) }),
            react_1.default.createElement(form_number_field_1.FormNumberField, { name: "period", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_SHREDDING_MODES_FIELD_LABEL_PERIOD", defaultMessage: "Skarta\u010Dn\u00ED lh\u016Fta" }) })),
        react_1.default.createElement(identifier_1.Identifier, null)));
}
exports.ShreddingModesFields = ShreddingModesFields;
//# sourceMappingURL=shredding-modes-fields.js.map